/*!
 * devextreme-angular
 * Version: 24.2.7
 * Build date: Mon Apr 28 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import { AnimationConfig } from 'devextreme/common/core/animation';

import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-menu-animation',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoMenuAnimationComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get hide(): AnimationConfig {
        return this._getOption('hide');
    }
    set hide(value: AnimationConfig) {
        this._setOption('hide', value);
    }

    @Input()
    get show(): AnimationConfig {
        return this._getOption('show');
    }
    set show(value: AnimationConfig) {
        this._setOption('show', value);
    }


    protected get _optionPath() {
        return 'animation';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoMenuAnimationComponent
  ],
  exports: [
    DxoMenuAnimationComponent
  ],
})
export class DxoMenuAnimationModule { }
